import * as React from "react";
import {Button} from "@bizform/primereact/components/button/Button";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {ComponentElement, ComponentElementStatic} from "@bizform/type/model/component_element/ComponentElement.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {Debug} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    ComponentElementClass,
    FormContentService,
    FormDataSchemaService,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";


type Props =  {
};

type State =  {
    uniqueId: string
};

/**
 * Data Link Handler
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfDataLink extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.DATALINKHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_1rnfOz5GzhCe8MvTekMoP7lfi0XUlAR",
        category: ComponentCategory.HANDLER,
        label: "Data Link Handler",
        description: "Data Link Handler",
        icon: "",
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        dataType: [DataType.ANY, DataType.BOOLEAN, DataType.DATE, DataType.DATEARRAY, DataType.DATETIME, DataType.UTCDATE, DataType.UTCDATEARRAY, DataType.UTCDATETIME, DataType.INTEGER, DataType.INTEGERARRAY, DataType.LOOKUP, DataType.LOOKUPARRAY, DataType.NUMBER, DataType.NUMBERARRAY, DataType.STRING, DataType.STRINGARRAY, DataType.TIME, DataType.UTCTIME, DataType.TRISTATE, DataType.USER],
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    dataType: DataType;
    parentDom: HTMLElement;

    /** action */
    emit(value: null) {}
    subscription(value: null) {}
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    focus() {}
    setProperty(property: ComponentElementProperty) {
        this.setState({
            uniqueId: property && property.attribute && property.attribute.uniqueId &&  property.attribute.uniqueId.value ? property.attribute.uniqueId.value : ""
        });
    }

    @ReactComponentElementInit(BfDataLink)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;
    private _ref: HTMLInputElement;

    constructor(props?: Props) {
        super(props);
        this.state = {
            uniqueId: null
        };
        this._onCopy = this._onCopy.bind(this);
        this._setRef = this._setRef.bind(this);
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return this.state.uniqueId !== nextState.uniqueId;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if ((window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE]) && this.elementId) {
            const value = FormContentService.getValue(this.applicationId, (this as any).___props.formId, this.elementId.substring(this.elementId.indexOf("-") + 1, this.elementId.length));
            if (value) {
                if (value.dataField) {
                    const schema = FormDataSchemaService.getProjectDataSchemaFieldData(this.applicationId, value.dataField);
                    if (schema && schema.name) {
                        return (
                            <div className={"w-100 h-100 text-center p-1"} style={{fontSize: "12px", "border": "2px solid rgba(0, 0, 255, 0.3)", "backgroundColor": "rgba(0, 0, 255, 0.1)"}}>
                                <b className={"bf-text-indigo5"}>Data Link : {schema.name} / Access Key : <input ref={this._setRef} type="text" value={value.dataField} className={"bf-text-indigo5"} style={{backgroundColor: "rgba(0, 0, 0, 0)", border: "none", width: "250px", fontWeight: "bold"}} disabled={true}/></b>
                                <Button
                                    icon={"far fa-copy"}
                                    className="p-0 p-button-primary"
                                    onClick={this._onCopy}
                                    label="Copy Access Key"
                                />
                            </div>
                        );
                    }
                }
            }
            return (
                <div className={"w-100 h-100 text-center p-1"} style={{"border": "2px solid rgba(255, 0, 0, 0.3)", "backgroundColor": "rgba(255, 0, 0, 0.1)"}}><b className={"bf-text-red5"}>Data Link : Unlinked Schema</b></div>
            );
        } else {
            return null;
        }
    }

    private _show() {
        this.setState({
            uniqueId: this.elementId
        });
    }

    private _setRef(ref): void {
        if (ref) {
            this._ref = ref;
        }
    }

    private _onCopy(): void {
        if (this._ref) {
            this._ref.readOnly = true;
            this._ref.disabled = false;
            this._ref.select();
            document.execCommand("copy");
            this._ref.disabled = true;
            this._ref.readOnly = false;
            this._ref.blur();
        }
    }
}
